<script lang="ts">
  import type { Game } from '$lib/types';
  import { ProgressiveImage } from '$mds/Image';

  export let game: Game;
  let className = '';
  export { className as class };
  export let sizes = { xs: 24 };
  export let border = '';
  export let rounded = '';
  export let align = '';
  export let square = true;
  export let link = true;

  const { class: _, ...restProps } = $$props;
</script>

<!-- Sometimes need to disable the <a> functionality because the game poster is already
  within an <a>, and nesting them is illegal. -->
{#if link}
  <a href="/{game.slug}" class="shrink-0 {className} {rounded}">
    <svelte:self {...{ ...restProps, link: false }} />
  </a>
{:else if game.poster}
  <ProgressiveImage
    src={game.poster}
    alt={game.title?.en || game.title}
    class="{square ? 'object-cover' : ''} {className}"
    aspect={square ? '1' : undefined}
    {sizes}
    {border}
    {rounded}
    {align}
    fit={square ? 'crop' : 'cover'}
  />
{/if}
